<div class="base-list">
  <p-table
    [value]="data"
    [lazy]="true"
    [paginator]="paginator"
    [rows]="rows"
    [totalRecords]="totalRecords"
    [loading]="loading"
    [rowsPerPageOptions]="rowsPerPageOptions"
    [first]="first"
    [sortField]="defaultSortField"
    [sortOrder]="defaultSortOrder"
    [showGridlines]="showGridlines"
    [stripedRows]="stripedRows"
    [rowHover]="rowHover"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="{first} - {last} / {totalRecords}"
    (onLazyLoad)="onLazyLoad($event)"
    [tableStyle]="{ 'min-width': '100%' }"
    [expandedRowKeys]="expandedRowKeys"
    [dataKey]="dataKey"
    (onRowExpand)="onRowExpandEvent($event)"
    styleClass="base-list__table">

    <ng-template #header>
      <tr>
        <th *ngIf="isExpandable" style="width: 3rem"></th>
        <th
          *ngFor="let col of visibleColumns; trackBy: trackByColumn"
          [pSortableColumn]="col.sortable ? (col.sorterField || col.field) : undefined"
          [style.width]="col.width || 'auto'">
          {{ col.header }}
          <p-sortIcon *ngIf="col.sortable" [field]="col.sorterField || col.field" />
        </th>
      </tr>
    </ng-template>

    <ng-template #body let-row let-expanded="expanded">
      <tr class="base-list__row" [ngClass]="getRowClass(row)" (click)="onRowClick(row)">
        <td *ngIf="isExpandable" style="width: 3rem">
          <button
            type="button"
            class="p-link"
            [pRowToggler]="row"
            [attr.aria-expanded]="expanded">
            <i [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
          </button>
        </td>
        <td *ngFor="let col of visibleColumns; trackBy: trackByColumn">
          <ng-container *ngIf="col.bodyTemplate; else defaultCell">
            <ng-container
              *ngTemplateOutlet="col.bodyTemplate; context: { $implicit: row, column: col }">
            </ng-container>
          </ng-container>
          <ng-template #defaultCell>
            <ng-container [ngSwitch]="col.type">
              <span *ngSwitchCase="'date'">
                {{ getCellValue(row, col) | displayDateTime }}
              </span>
              <span *ngSwitchCase="'number'">
                {{ getCellValue(row, col) | number }}
              </span>
              <span *ngSwitchCase="'boolean'">
                <i
                  class="fas"
                  [ngClass]="getCellValue(row, col) ? 'fa-check text-success' : 'fa-times text-danger'">
                </i>
              </span>
              <span *ngSwitchDefault>{{ getCellValue(row, col) }}</span>
            </ng-container>
          </ng-template>
        </td>
      </tr>
    </ng-template>

    <ng-template #expandedrow let-row>
      <tr *ngIf="rowExpandTemplate">
        <td [attr.colspan]="bodyColspan" class="p-0">
          <ng-container *ngTemplateOutlet="rowExpandTemplate; context: { $implicit: row }">
          </ng-container>
        </td>
      </tr>
    </ng-template>

    <ng-template #paginatorleft>
      @if (config?.totalLabelFn) {
        <span class="base-list__total-label small text-muted">{{ config.totalLabelFn!(totalRecords) }}</span>
      }
    </ng-template>

    <ng-template #paginatorright>
      <div class="d-inline-flex align-items-center gap-1">
        @if (showColumnPicker) {
          <button
            type="button"
            class="base-list__icon-btn d-inline-flex align-items-center justify-content-center flex-shrink-0 p-0 border-0 bg-transparent"
            [pTooltip]="columnPickerLabel"
            tooltipPosition="top"
            [attr.aria-label]="columnPickerLabel"
            aria-haspopup="dialog"
            (click)="columnPickerPopover.toggle($event)">
            <i class="pi pi-objects-column"></i>
          </button>

          <!-- appendTo="body": a paginator inside a scroll container would clip the panel. -->
          <p-popover #columnPickerPopover appendTo="body" [dismissable]="true" [focusOnShow]="false">
            <div class="base-list__column-picker p-1">
              <p class="base-list__column-picker-title small text-muted mb-2 px-2">{{ columnsLabel }}</p>

              <ul class="list-unstyled d-flex flex-column gap-1 m-0">
                @for (col of hideableColumns; track col.field) {
                  <li>
                    <label class="base-list__column-picker-option d-flex align-items-center gap-2 px-2 py-1 rounded-2 mb-0">
                      <input
                        type="checkbox"
                        class="form-check-input flex-shrink-0 mt-0"
                        [checked]="isColumnVisible(col)"
                        [disabled]="isLastVisibleColumn(col)"
                        (change)="toggleColumn(col)" />
                      <span class="text-truncate">{{ col.header }}</span>
                    </label>
                  </li>
                }
              </ul>
            </div>
          </p-popover>
        }

        <button
          type="button"
          class="base-list__icon-btn d-inline-flex align-items-center justify-content-center flex-shrink-0 p-0 border-0 bg-transparent"
          [pTooltip]="refreshLabel"
          tooltipPosition="top"
          (click)="refresh()">
          <i class="pi pi-refresh"></i>
        </button>
      </div>
    </ng-template>

    <ng-template #emptymessage>
      <tr>
        <td [attr.colspan]="bodyColspan" class="base-list__empty">
          <div class="base-list__empty-content d-flex flex-column align-items-center gap-2 text-muted">
            <i class="fas fa-inbox"></i>
            <span class="small">{{ emptyMessage }}</span>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template #loadingbody>
      <tr *ngFor="let _ of [1, 2, 3, 4, 5]">
        <td *ngIf="isExpandable"></td>
        <td *ngFor="let col of visibleColumns; trackBy: trackByColumn">
          <div class="base-list__skeleton"></div>
        </td>
      </tr>
    </ng-template>

  </p-table>
</div>
